{
  "about.blocks": "Moderované servery",
  "about.contact": "Kontakt:",
  "about.default_locale": "Predvolený",
  "about.disclaimer": "Mastodon je bezplatný open-source softvér s otvoreným zdrojovým kódom a ochranná známka spoločnosti Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Dôvod nebol uvedený",
  "about.domain_blocks.preamble": "Mastodon vo všeobecnosti umožňuje prezerať obsah a komunikovať s používateľmi z akéhokoľvek iného servera vo fediverze. Tu sú uvedené výnimky, ktoré boli urobené na tomto konkrétnom serveri.",
  "about.domain_blocks.silenced.explanation": "Vo všeobecnosti neuvidíte profily a obsah z tohto servera, pokiaľ si ich nevyhľadáte alebo sa neprihlásite k ich sledovaniu.",
  "about.domain_blocks.silenced.title": "Obmedzený",
  "about.domain_blocks.suspended.explanation": "Žiadne údaje z tohto servera nebudú spracovávané, ukladané ani vymieňané, čo znemožní akúkoľvek interakciu alebo komunikáciu s používateľmi z tohto servera.",
  "about.domain_blocks.suspended.title": "Vylúčený",
  "about.language_label": "Jazyk",
  "about.not_available": "Tieto informácie neboli sprístupnené na tomto serveri.",
  "about.powered_by": "Decentralizovaná sociálna sieť na základe technológie {mastodon}",
  "about.rules": "Pravidlá servera",
  "account.account_note_header": "Osobná poznámka",
  "account.activity": "Aktivita",
  "account.add_or_remove_from_list": "Pridať alebo odobrať zo zoznamov",
  "account.badges.bot": "Bot",
  "account.badges.group": "Skupina",
  "account.block": "Blokovať @{name}",
  "account.block_domain": "Blokovať doménu {domain}",
  "account.block_short": "Blokovať",
  "account.blocked": "Účet blokovaný",
  "account.cancel_follow_request": "Zrušiť žiadosť o sledovanie",
  "account.copy": "Skopírovať odkaz na profil",
  "account.direct": "Súkromne označiť @{name}",
  "account.disable_notifications": "Zrušiť upozornenia na príspevky od @{name}",
  "account.edit_profile": "Upraviť profil",
  "account.edit_profile_short": "Upraviť",
  "account.enable_notifications": "Zapnúť upozornenia na príspevky od @{name}",
  "account.endorse": "Zobraziť na vlastnom profile",
  "account.familiar_followers_many": "Sleduje {name1}, {name2} a {othersCount, plural, one {ďalší účet, ktorý poznáte} few {# ďalšie účty, ktoré poznáte} many {#} other {# ďalších účtov, ktoré poznáte}}",
  "account.familiar_followers_one": "Nasledovanie od {name1}",
  "account.familiar_followers_two": "Nasledovanie od {name1} a {name2}",
  "account.featured": "Zviditeľnené",
  "account.featured.accounts": "Profily",
  "account.filters.posts_only": "Príspevky",
  "account.filters.posts_replies": "Príspevky a odpovede",
  "account.follow": "Sledovať",
  "account.follow_back": "Sledovať späť",
  "account.follow_back_short": "Sledovať späť",
  "account.follow_request": "Požiadať o sledovanie",
  "account.follow_request_cancel": "Zrušiť žiadosť",
  "account.follow_request_cancel_short": "Zrušiť",
  "account.follow_request_short": "Požiadať",
  "account.followers": "Sledujúce účty",
  "account.followers.empty": "Ešte nikto nesleduje tohto užívateľa.",
  "account.followers_counter": "{count, plural, one {{counter} sledujúci účet} few {{counter} sledujúce účty} many {{counter} followers} other {{counter} sledujúcich účtov}}",
  "account.followers_you_know_counter": "{count, one {{counter}, ktorý poznáte}, few {{counter}, ktoré poznáte}, many {{counter}, kterých znáte} other {{counter}, ktoré poznáte}}",
  "account.following": "Sledovaných účtov",
  "account.following_counter": "{count, plural, one {{counter} sledovaných} other {{counter} sledovaných}}",
  "account.follows.empty": "Tento účet ešte nikoho nesleduje.",
  "account.follows_you": "Sleduje vás",
  "account.go_to_profile": "Prejsť na profil",
  "account.hide_reblogs": "Skryť zdieľania od @{name}",
  "account.in_memoriam": "In memoriam.",
  "account.joined_short": "Dátum registrácie",
  "account.languages": "Zmeniť odoberané jazyky",
  "account.link_verified_on": "Vlastníctvo tohto odkazu bolo skontrolované {date}",
  "account.locked_info": "Stav súkromia pre tento účet je nastavený na zamknutý. Jeho vlastník sa sám rozhoduje, kto ho môže sledovať.",
  "account.media": "Médiá",
  "account.mention": "Označiť @{name}",
  "account.moved_to": "{name} uvádza, že má nový účet:",
  "account.mute": "Stíšiť @{name}",
  "account.mute_notifications_short": "Stíšiť upozornenia",
  "account.mute_short": "Stíšiť",
  "account.muted": "Účet stíšený",
  "account.mutual": "Sledujete sa navzájom",
  "account.no_bio": "Nie je uvedený žiadny popis.",
  "account.open_original_page": "Otvoriť pôvodnú stránku",
  "account.posts": "Príspevky",
  "account.remove_from_followers": "Zrušiť sledovanie od {name}",
  "account.report": "Nahlásiť @{name}",
  "account.requested_follow": "{name} vás chce sledovať",
  "account.share": "Zdieľaj profil @{name}",
  "account.show_reblogs": "Zobrazovať zdieľania od @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} príspevok} other {{counter} príspevkov}}",
  "account.unblock": "Odblokovať @{name}",
  "account.unblock_domain": "Odblokovať doménu {domain}",
  "account.unblock_domain_short": "Odblokovať",
  "account.unblock_short": "Odblokovať",
  "account.unendorse": "Nezobrazovať na vlastnom profile",
  "account.unfollow": "Zrušiť sledovanie",
  "account.unmute": "Vypnúť stíšenie @{name}",
  "account.unmute_notifications_short": "Vypnúť stíšenie upozornení",
  "account.unmute_short": "Zrušiť stíšenie",
  "account_note.placeholder": "Kliknutím pridať poznámku",
  "admin.dashboard.daily_retention": "Miera udržania používateľov podľa dňa po registrácii",
  "admin.dashboard.monthly_retention": "Miera udržania používateľov podľa mesiaca po registrácii",
  "admin.dashboard.retention.average": "Priemer",
  "admin.dashboard.retention.cohort": "Dátum registrácie",
  "admin.dashboard.retention.cohort_size": "Nové účty",
  "admin.impact_report.instance_accounts": "Profily účtov, ktoré by boli odstránené",
  "admin.impact_report.instance_followers": "Sledovatelia, o ktorých by naši používatelia prišli",
  "admin.impact_report.instance_follows": "Sledovatelia, o ktorých by ich používatelia prišli",
  "admin.impact_report.title": "Zhrnutie dopadu",
  "alert.rate_limited.message": "Prosím, skúste to znova o {retry_time, time, medium}.",
  "alert.rate_limited.title": "Priveľa žiadostí",
  "alert.unexpected.message": "Vyskytla sa nečakaná chyba.",
  "alert.unexpected.title": "Ups!",
  "alt_text_badge.title": "Opis",
  "alt_text_modal.add_alt_text": "Pridať opis",
  "alt_text_modal.add_text_from_image": "Pridať text z obrázka",
  "alt_text_modal.cancel": "Zrušiť",
  "alt_text_modal.change_thumbnail": "Zmeniť náhľad",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Opíšte obsah pre ľudí so sluchovým postihnutím…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Opíšte obsah pre ľudí so zrakovým postihnutím…",
  "alt_text_modal.done": "Hotovo",
  "announcement.announcement": "Oznámenie",
  "annual_report.announcement.action_dismiss": "Nie, ďakujem",
  "annual_report.shared_page.donate": "Podporiť",
  "annual_report.summary.close": "Zavrieť",
  "annual_report.summary.copy_link": "Skopírovať odkaz",
  "annual_report.summary.most_used_app.most_used_app": "najviac používaná aplikácia",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "najviac užívaný hashtag",
  "annual_report.summary.new_posts.new_posts": "nové príspevky",
  "annual_report.summary.percentile.text": "<topLabel>Takže patríte do top</topLabel><percentage></percentage><bottomLabel>účtov na {domain}</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Nepovieme Berniemu.",
  "attachments_list.unprocessed": "(nespracované)",
  "audio.hide": "Skryť zvuk",
  "block_modal.remote_users_caveat": "Požiadame server {domain} o rešpektovanie vášho rozhodnutia. Nevieme to však zaručiť, keďže niektoré servery pristupujú k blokovaniu inak. Verejné príspevky sa stále môžu zobrazovať neprihláseným ľuďom.",
  "block_modal.show_less": "Zobraziť menej",
  "block_modal.show_more": "Zobraziť viac",
  "block_modal.they_will_know": "Môžu vidieť, že sú zablokovaní/ý.",
  "block_modal.title": "Blokovať užívateľa?",
  "boost_modal.combo": "Nabudúce môžete preskočiť stlačením {combo}",
  "boost_modal.reblog": "Zdieľať príspevok?",
  "boost_modal.undo_reblog": "Zrušiť zdieľanie?",
  "bundle_column_error.copy_stacktrace": "Kopírovať chybovú hlášku",
  "bundle_column_error.error.body": "Požadovanú stránku nebolo možné vykresliť. Môže to byť spôsobené chybou v našom kóde alebo problémom s kompatibilitou prehliadača.",
  "bundle_column_error.error.title": "Ale nie!",
  "bundle_column_error.network.body": "Pri pokuse o načítanie tejto stránky sa vyskytla chyba. Môže to byť spôsobené dočasným problémom s vaším internetovým pripojením alebo týmto serverom.",
  "bundle_column_error.network.title": "Chyba siete",
  "bundle_column_error.retry": "Skúste to znova",
  "bundle_column_error.return": "Prejdite späť na domovskú stránku",
  "bundle_column_error.routing.body": "Žiadaná stránka nebola nájdená. Ste si istí, že zadaná adresa URL je správna?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Zatvoriť",
  "bundle_modal_error.message": "Pri načítavaní tejto obrazovky nastala chyba.",
  "bundle_modal_error.retry": "Skúsiť znova",
  "closed_registrations.other_server_instructions": "Keďže Mastodon je decentralizovaný, môžete si vytvoriť účet na inom serveri a stále komunikovať s týmto serverom.",
  "closed_registrations_modal.description": "Vytvorenie účtu na {domain} nie je v súčasnosti možné, ale myslite na to, že na používanie Mastodonu nepotrebujete účet práve na {domain}.",
  "closed_registrations_modal.find_another_server": "Nájsť iný server",
  "closed_registrations_modal.preamble": "Mastodon je decentralizovaný, takže bez ohľadu na to, kde si vytvoríte účet, budete môcť sledovať a komunikovať s kýmkoľvek na tomto serveri. Môžete ho dokonca hostiť sami!",
  "closed_registrations_modal.title": "Registrácia na Mastodone",
  "column.about": "O tomto serveri",
  "column.blocks": "Blokované účty",
  "column.bookmarks": "Záložky",
  "column.community": "Miestna časová os",
  "column.create_list": "Vytvor zoznam",
  "column.direct": "Súkromné označenia",
  "column.directory": "Prehľadávať profily",
  "column.domain_blocks": "Blokované domény",
  "column.edit_list": "Uprav zoznam",
  "column.favourites": "Ohviezdičkované",
  "column.firehose": "Živé kanály",
  "column.follow_requests": "Žiadosti o sledovanie",
  "column.home": "Domov",
  "column.list_members": "Spravuj členov zoznamu",
  "column.lists": "Zoznamy",
  "column.mutes": "Stíšené účty",
  "column.notifications": "Upozornenia",
  "column.pins": "Pripnuté príspevky",
  "column.public": "Federovaná časová os",
  "column_back_button.label": "Späť",
  "column_header.hide_settings": "Skryť nastavenia",
  "column_header.moveLeft_settings": "Presunúť stĺpec doľava",
  "column_header.moveRight_settings": "Presunúť stĺpec doprava",
  "column_header.pin": "Pripnúť",
  "column_header.show_settings": "Zobraziť nastavenia",
  "column_header.unpin": "Odopnúť",
  "column_search.cancel": "Zruš",
  "community.column_settings.local_only": "Iba miestne",
  "community.column_settings.media_only": "Iba médiá",
  "community.column_settings.remote_only": "Iba vzdialené",
  "compose.error.blank_post": "Príspevok nemôže byť prázdny.",
  "compose.language.change": "Zmeniť jazyk",
  "compose.language.search": "Vyhľadávať jazyky…",
  "compose.published.body": "Príspevok zverejnený.",
  "compose.published.open": "Otvoriť",
  "compose.saved.body": "Príspevok uložený.",
  "compose_form.direct_message_warning_learn_more": "Viac informácií",
  "compose_form.encryption_warning": "Príspevky na Mastodone nie sú šifrované end-to-end. Nezdieľajte cez Mastodon žiadne citlivé informácie.",
  "compose_form.hashtag_warning": "Tento príspevok nebude zobrazený pod žiadným hashtagom, lebo nie je verejný. Iba verejné príspevky môžu byť nájdené podľa hashtagu.",
  "compose_form.lock_disclaimer": "Váš účet nie je {locked}. Ktokoľvek vás môže sledovať a vidieť vaše príspevky pre sledujúce účty.",
  "compose_form.lock_disclaimer.lock": "zamknutý",
  "compose_form.placeholder": "Na čo práve myslíte?",
  "compose_form.poll.duration": "Trvanie ankety",
  "compose_form.poll.multiple": "Viacero možností",
  "compose_form.poll.option_placeholder": "Možnosť {number}",
  "compose_form.poll.single": "Jediná voľba",
  "compose_form.poll.switch_to_multiple": "Zmeniť anketu a povoliť viaceré možnosti",
  "compose_form.poll.switch_to_single": "Zmeniť anketu na jediný povolený výber",
  "compose_form.poll.type": "Typ",
  "compose_form.publish": "Uverejniť",
  "compose_form.reply": "Odpovedať",
  "compose_form.save_changes": "Aktualizovať",
  "compose_form.spoiler.marked": "Odstrániť varovanie o obsahu",
  "compose_form.spoiler.unmarked": "Pridať varovanie o obsahu",
  "compose_form.spoiler_placeholder": "Varovanie o obsahu (voliteľné)",
  "confirmation_modal.cancel": "Zruš",
  "confirmations.block.confirm": "Zablokovať",
  "confirmations.delete.confirm": "Vymazať",
  "confirmations.delete.message": "Určite chcete tento príspevok vymazať?",
  "confirmations.delete.title": "Vymazať príspevok?",
  "confirmations.delete_list.confirm": "Vymazať",
  "confirmations.delete_list.message": "Určite chcete tento zoznam trvalo vymazať?",
  "confirmations.delete_list.title": "Vymazať zoznam?",
  "confirmations.discard_draft.confirm": "Zahodiť a pokračovať",
  "confirmations.discard_draft.edit.cancel": "Pokračovať v úpravách",
  "confirmations.discard_draft.edit.title": "Zahodiť zmeny v tvojom príspevku?",
  "confirmations.discard_draft.post.cancel": "Pokračuj v rozpísanom",
  "confirmations.discard_draft.post.title": "Zahodiť tvoj rozpísaný príspevok?",
  "confirmations.discard_edit_media.confirm": "Zahodiť",
  "confirmations.discard_edit_media.message": "Máte neuložené zmeny v popise alebo náhľade média, zahodiť ich aj tak?",
  "confirmations.follow_to_list.confirm": "Nasleduj a pridaj do zoznamu",
  "confirmations.follow_to_list.message": "Musíš nasledovať {name} aby si ho/ju mohol/la pridať do zoznamu.",
  "confirmations.follow_to_list.title": "Nasleduj užívateľa?",
  "confirmations.logout.confirm": "Odhlásiť sa",
  "confirmations.logout.message": "Určite sa chcete odhlásiť?",
  "confirmations.logout.title": "Odhlásiť sa?",
  "confirmations.missing_alt_text.confirm": "Pridať opis",
  "confirmations.missing_alt_text.message": "Váš príspevok obsahuje médiá bez opisu. Pridanie opisu sprístupňuje váš obsah viac ľuďom.",
  "confirmations.missing_alt_text.secondary": "Aj tak uverejniť",
  "confirmations.missing_alt_text.title": "Pridať opis?",
  "confirmations.mute.confirm": "Stíšiť",
  "confirmations.private_quote_notify.cancel": "Späť na úpravu",
  "confirmations.private_quote_notify.confirm": "Zverejni príspevok",
  "confirmations.private_quote_notify.do_not_show_again": "Neukazuj mi túto spravu znova",
  "confirmations.private_quote_notify.title": "Zdieľať z nasledovateľmi a spomenutými užívateľmi?",
  "confirmations.quiet_post_quote_info.dismiss": "Nepripomínaj mi znova",
  "confirmations.quiet_post_quote_info.got_it": "Mám to",
  "confirmations.redraft.confirm": "Vymazať a prepísať",
  "confirmations.redraft.message": "Určite chcete tento príspevok vymazať a prepísať? Prídete o jeho zdieľania a ohviezdičkovania a odpovede na pôvodný príspevok budú odlúčené.",
  "confirmations.redraft.title": "Vymazať a prepísať príspevok?",
  "confirmations.remove_from_followers.confirm": "Odstrániť nasledovateľa",
  "confirmations.revoke_quote.confirm": "Vymazať príspevok",
  "confirmations.revoke_quote.message": "Tento úkon sa nedá navrátiť.",
  "confirmations.revoke_quote.title": "Vymazať príspevok?",
  "confirmations.unblock.confirm": "Odblokovať",
  "confirmations.unblock.title": "Odblokovať {name}?",
  "confirmations.unfollow.confirm": "Zrušiť sledovanie",
  "confirmations.unfollow.title": "Prestať sledovať {name}?",
  "content_warning.hide": "Skryť príspevok",
  "content_warning.show": "Aj tak zobraziť",
  "content_warning.show_more": "Ukázať viac",
  "conversation.delete": "Vymazať konverzáciu",
  "conversation.mark_as_read": "Označiť ako prečítanú",
  "conversation.open": "Zobraziť konverzáciu",
  "conversation.with": "S {names}",
  "copy_icon_button.copied": "Skopírované do schránky",
  "copypaste.copied": "Skopírované",
  "copypaste.copy_to_clipboard": "Skopírovať do schránky",
  "directory.federated": "Zo známého fediverza",
  "directory.local": "Iba z {domain}",
  "directory.new_arrivals": "Nové príchody",
  "directory.recently_active": "Nedávna aktivita",
  "disabled_account_banner.account_settings": "Nastavenia účtu",
  "disabled_account_banner.text": "Váš účet {disabledAccount} je momentálne deaktivovaný.",
  "dismissable_banner.community_timeline": "Toto sú najnovšie verejné príspevky od účtov hostených na {domain}.",
  "dismissable_banner.dismiss": "Zrušiť",
  "domain_block_modal.block": "Blokovať server",
  "domain_block_modal.block_account_instead": "Namiesto toho zablokuj @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Ľudia z tohto servera môžu interaktovať s tvojimi starými príspevkami.",
  "domain_block_modal.they_cant_follow": "Nikto z tohoto servera ťa nemôže nasledovať.",
  "domain_block_modal.they_wont_know": "Nebude vedieť, že bol/a zablokovaný/á.",
  "domain_block_modal.title": "Blokovať doménu?",
  "domain_block_modal.you_will_lose_relationships": "Stratíš všetkých sledovateľov a ľudí, ktorých ty na tomto serveri nasleduješ.",
  "domain_block_modal.you_wont_see_posts": "Neuvidíš príspevky, ani oboznámenia od užívateľov na tomto serveri.",
  "domain_pill.activitypub_like_language": "ActivityPub je ako jazyk, ktorým Mastodon hovorí s ostatnými sociálnymi sieťami.",
  "domain_pill.server": "Server",
  "domain_pill.their_server": "Ich digitálny domov, kde žijú všetky ich príspevky.",
  "domain_pill.username": "Používateľské meno",
  "dropdown.empty": "Vyber možnosť",
  "embed.instructions": "Tento príspevok môžete pridať na svoju webovú stránku použitím tohto kódu.",
  "embed.preview": "Takto bude vyzerať:",
  "emoji_button.activity": "Aktivita",
  "emoji_button.clear": "Vyčistiť",
  "emoji_button.custom": "Vlastné",
  "emoji_button.flags": "Vlajky",
  "emoji_button.food": "Jedlá a nápoje",
  "emoji_button.label": "Vložiť emotikony",
  "emoji_button.nature": "Príroda",
  "emoji_button.not_found": "Žiadne emotikony",
  "emoji_button.objects": "Predmety",
  "emoji_button.people": "Ľudia",
  "emoji_button.recent": "Často používané",
  "emoji_button.search": "Hľadať…",
  "emoji_button.search_results": "Výsledky hľadania",
  "emoji_button.symbols": "Symboly",
  "emoji_button.travel": "Cestovanie a miesta",
  "empty_column.account_hides_collections": "Tento účet sa rozhodol túto informáciu nesprístupniť",
  "empty_column.account_suspended": "Účet bol pozastavený",
  "empty_column.account_timeline": "Nie sú tu žiadne príspevky.",
  "empty_column.account_unavailable": "Profil nedostupný",
  "empty_column.blocks": "Nemáte blokované žiadne účty.",
  "empty_column.bookmarked_statuses": "Ešte nemáte záložku v žiadnom príspevku. Keď si ju do nejakého príspevku pridáte, zobrazí sa tu.",
  "empty_column.community": "Miesta časová os je prázdna. Napíšte niečo, aby to tu ožilo!",
  "empty_column.direct": "Ešte nemáte žiadne súkromné označenia. Keď nejaké pošlete alebo dostanete, zobrazí sa tu.",
  "empty_column.domain_blocks": "Žiadne domény ešte nie sú blokované.",
  "empty_column.explore_statuses": "Momentálne nie je nič populárne. Skontrolujte to zas neskôr.",
  "empty_column.favourited_statuses": "Zatiaľ nemáte žiadne ohviezdičkované príspevky. Akonáhle nejaký ohviezdičkujete, zobrazí sa tu.",
  "empty_column.favourites": "Zatiaľ tento príspevok nikto neohviezdičkoval. Akonáhle sa tak stane, zobrazí sa tu.",
  "empty_column.follow_requests": "Zatiaľ nemáte žiadne žiadosti o sledovanie. Keď nejakú dostanete, zobrazí sa tu.",
  "empty_column.followed_tags": "Zatiaľ nesledujete žiadne hashtagy. Keď tak urobíte, zobrazia sa tu.",
  "empty_column.hashtag": "Pod týmto hashtagom sa ešte nič nenachádza.",
  "empty_column.home": "Vaša domáca časová os je zatiaľ prázdna. Začnite sledovať ostatných a naplňte si ju.",
  "empty_column.list": "Tento zoznam je zatiaľ prázdny. Keď ale členovia tohoto zoznamu uverejnia nové príspevky, objavia sa tu.",
  "empty_column.mutes": "Zatiaľ ste si nikoho nestíšili.",
  "empty_column.notification_requests": "Všetko čisté! Nič tu nieje. Keď dostaneš nové oboznámenia, zobrazia sa tu podľa tvojich nastavení.",
  "empty_column.notifications": "Zatiaľ nemáte žiadne upozornenia. Začnú vám pribúdať, keď s vami začnú interagovať ostatní.",
  "empty_column.public": "Zatiaľ tu nič nie je. Napíšte niečo verejné alebo začnite sledovať účty z iných serverov, aby tu niečo pribudlo.",
  "error.unexpected_crash.explanation": "Pre chybu v našom kóde alebo problém s kompatibilitou prehliadača nebolo túto stránku možné zobraziť správne.",
  "error.unexpected_crash.explanation_addons": "Túto stránku sa nepodarilo zobraziť správne. Táto chyba je pravdepodobne spôsobená rozšírením v prehliadači alebo nástrojmi automatického prekladu.",
  "error.unexpected_crash.next_steps": "Skúste stránku obnoviť. Ak to nepomôže, pravdepodobne budete stále môcť používať Mastodon cez iný prehliadač alebo natívnu aplikáciu.",
  "error.unexpected_crash.next_steps_addons": "Skúste ich vypnúť a stránku obnoviť. Ak to nepomôže, pravdepodobne budete stále môcť Mastodon používať cez iný prehliadač alebo natívnu aplikáciu.",
  "errors.unexpected_crash.copy_stacktrace": "Kopírovať stacktrace do schránky",
  "errors.unexpected_crash.report_issue": "Nahlásiť problém",
  "explore.suggested_follows": "Ľudia",
  "explore.trending_links": "Správy",
  "explore.trending_statuses": "Príspevky",
  "explore.trending_tags": "Hashtagy",
  "featured_carousel.header": "{count, plural, one {Pripnutý príspevok} few {Pripnuté príspevky} many {} other {Pripnutých príspevkov}}",
  "filter_modal.added.context_mismatch_explanation": "Táto kategória filtrov sa nevzťahuje na kontext, v ktorom ste získali prístup k tomuto príspevku. Ak chcete, aby sa príspevok filtroval aj v tomto kontexte, budete musieť filter upraviť.",
  "filter_modal.added.context_mismatch_title": "Nesúlad kontextu!",
  "filter_modal.added.expired_explanation": "Platnosť tejto kategórie filtra vypršala, aby sa použila, je potrebné zmeniť dátum vypršania platnosti.",
  "filter_modal.added.expired_title": "Vypršala platnosť filtra!",
  "filter_modal.added.review_and_configure": "Ak chcete skontrolovať a ďalej konfigurovať túto kategóriu filtrov, prejdite na odkaz {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Nastavenia filtrov",
  "filter_modal.added.settings_link": "stránka nastavení",
  "filter_modal.added.short_explanation": "Tento príspevok bol pridaný do nasledujúcej kategórie filtrov: {title}.",
  "filter_modal.added.title": "Filter bol pridaný.",
  "filter_modal.select_filter.context_mismatch": "sa na tento kontext nevzťahuje",
  "filter_modal.select_filter.expired": "vypršal",
  "filter_modal.select_filter.prompt_new": "Nová kategória: {name}",
  "filter_modal.select_filter.search": "Vyhľadať alebo vytvoriť",
  "filter_modal.select_filter.subtitle": "Použite existujúcu kategóriu alebo vytvorte novú",
  "filter_modal.select_filter.title": "Filtrovanie tohto príspevku",
  "filter_modal.title.status": "Filtrovanie príspevku",
  "filtered_notifications_banner.title": "Filtrované oznámenia",
  "firehose.all": "Všetko",
  "firehose.local": "Tento server",
  "firehose.remote": "Ostatné servery",
  "follow_request.authorize": "Povoliť",
  "follow_request.reject": "Zamietnuť",
  "follow_requests.unlocked_explanation": "Aj keď váš účet nie je uzamknutý, tím domény {domain} si myslel, že môžete chcieť skontrolovať žiadosti o sledovanie z týchto účtov manuálne.",
  "follow_suggestions.curated_suggestion": "Výber redakcie",
  "follow_suggestions.dismiss": "Znova nezobrazovať",
  "follow_suggestions.featured_longer": "Ručne vybrané tímom {domain}",
  "follow_suggestions.friends_of_friends_longer": "Populárne medzi ľudmi ktorých nasleduješ",
  "follow_suggestions.hints.featured": "Tento profil bol ručne zvolený tímom domény {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Tento profil je obľúbený medzi účtami, ktoré sledujete.",
  "follow_suggestions.hints.most_followed": "Tento profil patrí na doméne {domain} medzi najsledovanejšie.",
  "follow_suggestions.hints.most_interactions": "Tento profil má v poslednej dobe na doméne {domain} veľa interakcií.",
  "follow_suggestions.hints.similar_to_recently_followed": "Tento profil je podobný profilom, ktoré ste nedávno začali sledovať.",
  "follow_suggestions.personalized_suggestion": "Prispôsobený návrh",
  "follow_suggestions.popular_suggestion": "Obľúbený návrh",
  "follow_suggestions.popular_suggestion_longer": "Populárne na {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Podobné profilom, ktoré si nedávno nasledoval/a",
  "follow_suggestions.view_all": "Zobraziť všetky",
  "follow_suggestions.who_to_follow": "Koho sledovať",
  "followed_tags": "Sledované hashtagy",
  "footer.about": "Viac informácií",
  "footer.about_this_server": "O",
  "footer.directory": "Adresár profilov",
  "footer.get_app": "Stiahnuť aplikáciu",
  "footer.keyboard_shortcuts": "Klávesové skratky",
  "footer.privacy_policy": "Pravidlá ochrany súkromia",
  "footer.source_code": "Zobraziť zdrojový kód",
  "footer.status": "Stav",
  "footer.terms_of_service": "Podmienky prevozu",
  "generic.saved": "Uložené",
  "getting_started.heading": "Začíname",
  "hashtag.admin_moderation": "Otvor moderovacie rozhranie pre #{name}",
  "hashtag.browse": "Prehľadávať príspevky pod #{hashtag}",
  "hashtag.browse_from_account": "Prehľadávať príspevky od @{name} pre #{hashtag}",
  "hashtag.column_header.tag_mode.all": "a {additional}",
  "hashtag.column_header.tag_mode.any": "alebo {additional}",
  "hashtag.column_header.tag_mode.none": "bez {additional}",
  "hashtag.column_settings.select.no_options_message": "Žiadne návrhy neboli nájdené",
  "hashtag.column_settings.select.placeholder": "Zadajte hashtagy…",
  "hashtag.column_settings.tag_mode.all": "Všetky tieto",
  "hashtag.column_settings.tag_mode.any": "Ľubovoľné z týchto",
  "hashtag.column_settings.tag_mode.none": "Žiaden z týchto",
  "hashtag.column_settings.tag_toggle": "Vložte dodatočné hashtagy pre tento stĺpec",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} prispievajúci účet} few {{counter} prispievajúce účty} many {{counter} participants} other {{counter} prispievajúcich účtov}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} príspevok} few {{counter} príspevky} many {{counter} príspevkov} other {{counter} príspevkov}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} príspevok} few {{counter} príspevky} many {{counter} príspevkov} other {{counter} príspevkov}} dnes",
  "hashtag.follow": "Sledovať hashtag",
  "hashtag.mute": "Utlmiť #{hashtag}",
  "hashtag.unfollow": "Zrušiť sledovanie hashtagu",
  "hashtags.and_other": "…a {count, plural, other {# ďalších}}",
  "hints.profiles.followers_may_be_missing": "Nasledovatelia tohto profilu môžu chýbať.",
  "hints.profiles.follows_may_be_missing": "Nasledovatelia tohto profilu môžu chýbať.",
  "hints.profiles.posts_may_be_missing": "Niektoré príspevky z tohto profilu môžu chýbať.",
  "hints.profiles.see_more_followers": "Pozri viac nasledovateľov na {domain}",
  "hints.profiles.see_more_follows": "Pozri viac nasledovateľov na {domain}",
  "hints.profiles.see_more_posts": "Pozri viac príspevkov na {domain}",
  "home.column_settings.show_reblogs": "Zobraziť zdieľania",
  "home.column_settings.show_replies": "Zobraziť odpovede",
  "home.hide_announcements": "Skryť oznámenia",
  "home.pending_critical_update.body": "Prosíme, aktualizujte si svoj Mastodon server, hneď ako to bude možné.",
  "home.pending_critical_update.link": "Zobraziť aktualizácie",
  "home.pending_critical_update.title": "Je dostupná kritická bezpečnostná aktualizácia.",
  "home.show_announcements": "Zobraziť oznámenia",
  "ignore_notifications_modal.filter_instead": "Radšej triediť",
  "ignore_notifications_modal.filter_to_act_users": "Stále budeš môcť akceptovať, odmietnuť, alebo nahlásiť užívateľov",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtrovanie pomáha vyvarovať sa možnému zmäteniu",
  "ignore_notifications_modal.ignore": "Ignoruj upozornenia",
  "ignore_notifications_modal.limited_accounts_title": "Ignorovať oboznámenia z obmedzených účtov?",
  "ignore_notifications_modal.new_accounts_title": "Nevšímať si oznámenia z nových účtov?",
  "ignore_notifications_modal.not_followers_title": "Nevšímať si oznámenia od ľudí, ktorí ťa nenasledujú?",
  "ignore_notifications_modal.not_following_title": "Nevšímať si oznámenia od ľudí, ktorých nenasleduješ?",
  "ignore_notifications_modal.private_mentions_title": "Nevšímať si oznámenia o nevyžiadaných súkromných spomínaniach?",
  "info_button.label": "Pomoc",
  "info_button.what_is_alt_text": "<h1>Čo je to opis?</h1> <p>Opis médií umožňuje ľuďom so zdravotným postihnutím alebo slabým pripojením porozumieť obsahu príspevku.</p> <p>Zrozumiteľné, stručné a objektívne opisy sprístupňujú a vysvetľujú váš obsah väčšiemu počtu ľudí.</p> <ul> <li>Spomeňte dôležité prvky</li> <li>Zhrňte text na obrázkoch a fotkách</li> <li>Píšte bežné vety</li> <li>Vynechajte zbytočné informácie</li> <li>Pri zložitých vizuáloch (napr. nákresoch či mapách) sa sústreďte na kľúčové vzorce a závery</li> </ul>",
  "interaction_modal.go": "Prejdi",
  "interaction_modal.no_account_yet": "Ešte nemáš účet?",
  "interaction_modal.on_another_server": "Na inom serveri",
  "interaction_modal.on_this_server": "Na tomto serveri",
  "interaction_modal.username_prompt": "Napr. {example}",
  "intervals.full.days": "{number, plural, one {# deň} few {# dni} many {# dní} other {# dní}}",
  "intervals.full.hours": "{number, plural, one {# hodina} few {# hodiny} many {# hodín} other {# hodín}}",
  "intervals.full.minutes": "{number, plural, one {# minúta} few {# minúty} many {# minút} other {# minút}}",
  "keyboard_shortcuts.back": "Ísť späť",
  "keyboard_shortcuts.blocked": "Otvoriť zoznam blokovaných užívateľov",
  "keyboard_shortcuts.boost": "Zdieľať príspevok",
  "keyboard_shortcuts.column": "Prejsť na stĺpec",
  "keyboard_shortcuts.compose": "Prejsť na textové pole",
  "keyboard_shortcuts.description": "Popis",
  "keyboard_shortcuts.down": "Posunúť sa dole v zozname",
  "keyboard_shortcuts.enter": "Otvoriť príspevok",
  "keyboard_shortcuts.favourite": "Ohviezdičkovať príspevok",
  "keyboard_shortcuts.favourites": "Otvoriť zoznam ohviezdičkovaných",
  "keyboard_shortcuts.federated": "Otvoriť federovanú časovú os",
  "keyboard_shortcuts.heading": "Klávesové skratky",
  "keyboard_shortcuts.home": "Otvoriť domácu časovú os",
  "keyboard_shortcuts.hotkey": "Kláves",
  "keyboard_shortcuts.legend": "Zobraziť túto legendu",
  "keyboard_shortcuts.local": "Otvoriť miestnu časovú os",
  "keyboard_shortcuts.mention": "Označiť autora",
  "keyboard_shortcuts.muted": "Otvoriť zoznam stíšených užívateľov",
  "keyboard_shortcuts.my_profile": "Otvoriť svoj profil",
  "keyboard_shortcuts.notifications": "Otvoriť panel upozornení",
  "keyboard_shortcuts.open_media": "Otvoriť médiá",
  "keyboard_shortcuts.pinned": "Otvoriť zoznam pripnutých príspevkov",
  "keyboard_shortcuts.profile": "Otvoriť autorov profil",
  "keyboard_shortcuts.reply": "Odpovedať na príspevok",
  "keyboard_shortcuts.requests": "Otvoriť zoznam žiadostí o sledovanie",
  "keyboard_shortcuts.search": "Prejsť na vyhľadávacie pole",
  "keyboard_shortcuts.spoilers": "Zobraziť/skryť pole varovania o obsahu",
  "keyboard_shortcuts.start": "Otvoriť panel „Začíname“",
  "keyboard_shortcuts.toggle_hidden": "Zobraziť/skryť text za varovaním o obsahu",
  "keyboard_shortcuts.toggle_sensitivity": "Zobraziť/skryť médiá",
  "keyboard_shortcuts.toot": "Vytvoriť nový príspevok",
  "keyboard_shortcuts.translate": "Preložiť príspevok",
  "keyboard_shortcuts.unfocus": "Odísť z textového poľa",
  "keyboard_shortcuts.up": "Posunúť sa vyššie v zozname",
  "learn_more_link.got_it": "Mám to",
  "learn_more_link.learn_more": "Zistiť viac",
  "lightbox.close": "Zatvoriť",
  "lightbox.next": "Ďalej",
  "lightbox.previous": "Späť",
  "lightbox.zoom_out": "Priblížiť na mieru",
  "limited_account_hint.action": "Aj tak zobraziť profil",
  "limited_account_hint.title": "Tento profil bol skrytý správcami servera {domain}.",
  "link_preview.author": "Autor: {name}",
  "link_preview.more_from_author": "Viac od {name}",
  "link_preview.shares": "{count, plural, one {{counter} príspevok} other {{counter} príspevkov}}",
  "lists.add_member": "Pridaj",
  "lists.add_to_list": "Pridaj do zoznamu",
  "lists.add_to_lists": "Pridaj {name} do zoznamov",
  "lists.create": "Vytvor",
  "lists.create_a_list_to_organize": "Vytvorte si nový zoznam na organizáciu svojho domovského kanála",
  "lists.create_list": "Vytvor zoznam",
  "lists.delete": "Vymazať zoznam",
  "lists.done": "Hotovo",
  "lists.edit": "Upraviť zoznam",
  "lists.exclusive": "Skryť členov na Domovskej osi",
  "lists.exclusive_hint": "Ak je niekto na tomto zozname, skry ich na tvojej Domácej osi, aby si ich príspevky nevidel/a dvakrát.",
  "lists.find_users_to_add": "Nájdi užívateľov na pridanie",
  "lists.list_name": "Názov zoznamu",
  "lists.new_list_name": "Názov nového zoznamu",
  "lists.no_lists_yet": "Zatiaľ nemáte žiadne zoznamy.",
  "lists.no_members_yet": "Zatiaľ bez členov.",
  "lists.no_results_found": "Žiadne výsledky nenájdené.",
  "lists.remove_member": "Odstráň",
  "lists.replies_policy.followed": "Akémukoľvek sledovanému účtu",
  "lists.replies_policy.list": "Členom zoznamu",
  "lists.replies_policy.none": "Nikomu",
  "lists.save": "Ulož",
  "lists.search": "Hľadaj",
  "lists.show_replies_to": "Zahrnúť odpovede od členov zoznamu na",
  "load_pending": "{count, plural, one {# nová položka} few {# nové položky} many {# nových položiek} other {# nových položiek}}",
  "loading_indicator.label": "Načítavanie…",
  "media_gallery.hide": "Skryť",
  "moved_to_account_banner.text": "Váš účet {disabledAccount} je momentálne deaktivovaný, pretože ste sa presunuli na {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Ukryť z upozornení",
  "mute_modal.hide_options": "Skryť možnosti",
  "mute_modal.indefinite": "Pokiaľ ich neodtíšim",
  "mute_modal.show_options": "Zobraziť možnosti",
  "mute_modal.they_can_mention_and_follow": "Môže ťa spomenúť a nasledovať, ale ty ho/ju neuvidíš.",
  "mute_modal.they_wont_know": "Nebude vedieť, že bol/a stíšený/á.",
  "mute_modal.title": "Stíšiť užívateľa?",
  "mute_modal.you_wont_see_mentions": "Neuvidíš príspevky, ktoré ho/ju spomínajú.",
  "mute_modal.you_wont_see_posts": "Stále uvidí tvoje príspevky, ale ty neuvidíš jeho/jej.",
  "navigation_bar.about": "O tomto serveri",
  "navigation_bar.account_settings": "Heslo a zabezpečenie",
  "navigation_bar.administration": "Spravovanie",
  "navigation_bar.advanced_interface": "Otvoriť v pokročilom webovom rozhraní",
  "navigation_bar.automated_deletion": "Automatické mazanie príspevkov",
  "navigation_bar.blocks": "Blokované účty",
  "navigation_bar.bookmarks": "Záložky",
  "navigation_bar.direct": "Súkromné označenia",
  "navigation_bar.domain_blocks": "Blokované domény",
  "navigation_bar.favourites": "Ohviezdičkované",
  "navigation_bar.filters": "Filtrované slová",
  "navigation_bar.follow_requests": "Žiadosti o sledovanie",
  "navigation_bar.followed_tags": "Sledované hashtagy",
  "navigation_bar.follows_and_followers": "Sledované a sledujúce účty",
  "navigation_bar.import_export": "Import a export",
  "navigation_bar.lists": "Zoznamy",
  "navigation_bar.logout": "Odhlásiť sa",
  "navigation_bar.moderation": "Moderovanie",
  "navigation_bar.more": "Viac",
  "navigation_bar.mutes": "Stíšené účty",
  "navigation_bar.opened_in_classic_interface": "Príspevky, účty a iné špeciálne stránky sú predvolene otvárané v klasickom webovom rozhraní.",
  "navigation_bar.preferences": "Nastavenia",
  "navigation_bar.privacy_and_reach": "Súkromie a dosah",
  "navigation_bar.search": "Hľadať",
  "not_signed_in_indicator.not_signed_in": "Ak chcete získať prístup k tomuto zdroju, prihláste sa.",
  "notification.admin.report": "Účet {name} nahlásil {target}",
  "notification.admin.report_statuses": "{name} nahlásil/a {target} za {category}",
  "notification.admin.report_statuses_other": "{name} nahlásil/a {target}",
  "notification.admin.sign_up": "Nová registráciu účtu {name}",
  "notification.favourite": "{name} hviezdičkuje váš príspevok",
  "notification.favourite_pm": "{name} obľúbil/a tvoje súkromné spomenutie",
  "notification.follow": "{name} vás sleduje",
  "notification.follow_request": "{name} vás žiada sledovať",
  "notification.label.mention": "Označenie",
  "notification.label.private_mention": "Súkromné označenie",
  "notification.label.private_reply": "Súkromná odpoveď",
  "notification.label.quote": "{name} citoval/a tvoj príspevok",
  "notification.label.reply": "Odpoveď",
  "notification.mention": "Označenie",
  "notification.mentioned_you": "{name} ťa spomenul/a",
  "notification.moderation-warning.learn_more": "Zisti viac",
  "notification.moderation_warning": "Dostal/a si varovanie od moderátora",
  "notification.moderation_warning.action_delete_statuses": "Niektoré z tvojich príspevkov boli odstránené.",
  "notification.moderation_warning.action_disable": "Tvoj účet bol vypnutý.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Niektoré vaše príspevky boli označené ako citlivé.",
  "notification.moderation_warning.action_none": "Tvoj účet dostal upozornenie od moderátora.",
  "notification.moderation_warning.action_sensitive": "Vaše príspevky budú odteraz označované ako citlivé.",
  "notification.moderation_warning.action_silence": "Tvoj účet bol obmedzený.",
  "notification.moderation_warning.action_suspend": "Tvoj účet bol pozastavený.",
  "notification.own_poll": "Vaša anketa sa skončila",
  "notification.poll": "Anketa, v ktorej si hlasoval/a, skončila",
  "notification.quoted_update": "{name} upravil/a príspevok, ktorý si citoval/a",
  "notification.reblog": "{name} zdieľa váš príspevok",
  "notification.reblog.name_and_others_with_link": "{name} a <a>{count, plural, one {# ďalší človek} few {# ďalší ľudia} many {#} other {# ďalších ľudí}}</a> zdieľa váš príspevok",
  "notification.relationships_severance_event": "Stratené prepojenia s {name}",
  "notification.relationships_severance_event.account_suspension": "Správca z {from} pozastavil/a {target}, čo znamená, že od nich viac nemôžeš dostávať aktualizácie, alebo s nimi interaktovať.",
  "notification.relationships_severance_event.learn_more": "Zisti viac",
  "notification.status": "{name} uverejňuje niečo nové",
  "notification.update": "{name} upravuje príspevok",
  "notification_requests.accept": "Prijať",
  "notification_requests.confirm_accept_multiple.title": "Priať požiadavku o oboznámenia?",
  "notification_requests.dismiss": "Zamietnuť",
  "notification_requests.edit_selection": "Uprav",
  "notification_requests.exit_selection": "Hotovo",
  "notification_requests.notifications_from": "Oboznámenia od {name}",
  "notification_requests.title": "Filtrované oznámenia",
  "notification_requests.view": "Zobraz upozornenia",
  "notifications.clear": "Vyčistiť upozornenia",
  "notifications.clear_confirmation": "Určite chcete nenávratne odstrániť všetky svoje upozornenia?",
  "notifications.clear_title": "Vyčistiť upozornenia?",
  "notifications.column_settings.admin.report": "Nové hlásenia:",
  "notifications.column_settings.admin.sign_up": "Nové registrácie:",
  "notifications.column_settings.alert": "Upozornenia na ploche",
  "notifications.column_settings.favourite": "Ohviezdičkované:",
  "notifications.column_settings.filter_bar.advanced": "Zobraziť všetky kategórie",
  "notifications.column_settings.follow": "Nové sledovania od:",
  "notifications.column_settings.follow_request": "Nové žiadosti o sledovanie od:",
  "notifications.column_settings.group": "Skupina",
  "notifications.column_settings.mention": "Označenia:",
  "notifications.column_settings.poll": "Výsledky ankety:",
  "notifications.column_settings.push": "Upozornenia push",
  "notifications.column_settings.quote": "Citácie:",
  "notifications.column_settings.reblog": "Zdieľania:",
  "notifications.column_settings.show": "Zobraziť v stĺpci",
  "notifications.column_settings.sound": "Prehrať zvuk",
  "notifications.column_settings.status": "Nové príspevky:",
  "notifications.column_settings.unread_notifications.category": "Neprečítané upozornenia",
  "notifications.column_settings.unread_notifications.highlight": "Zvýrazniť neprečítané upozornenia",
  "notifications.column_settings.update": "Úpravy:",
  "notifications.filter.all": "Všetky",
  "notifications.filter.boosts": "Zdieľania",
  "notifications.filter.favourites": "Ohviezdičkovania",
  "notifications.filter.follows": "Sledovania",
  "notifications.filter.mentions": "Označenia",
  "notifications.filter.polls": "Výsledky ankiet",
  "notifications.filter.statuses": "Novinky od ľudí, ktorých sledujete",
  "notifications.grant_permission": "Udeliť povolenie.",
  "notifications.group": "{count} upozornení",
  "notifications.mark_as_read": "Označiť všetky upozornenia ako prečítané",
  "notifications.permission_denied": "Upozornenia na ploche sú nedostupné pre už skôr zamietnutú požiadavku prehliadača",
  "notifications.permission_denied_alert": "Upozornenia na ploche nemôžu byť zapnuté, pretože požiadavka prehliadača bola už skôr zamietnutá",
  "notifications.permission_required": "Upozornenia na ploche sú nedostupné, pretože neboli udelené potrebné povolenia.",
  "notifications.policy.accept": "Prijať",
  "notifications.policy.accept_hint": "Ukáž v oznámeniach",
  "notifications.policy.drop": "Ignoruj",
  "notifications.policy.filter": "Triediť",
  "notifications.policy.filter_limited_accounts_hint": "Obmedzené moderátormi servera",
  "notifications.policy.filter_limited_accounts_title": "Moderované účty",
  "notifications.policy.filter_new_accounts_title": "Nové účty",
  "notifications.policy.filter_not_followers_title": "Ľudia, ktorí ťa nenasledujú",
  "notifications.policy.filter_not_following_hint": "Pokiaľ ich ručne neschváliš",
  "notifications.policy.filter_not_following_title": "Ľudia, ktorých nenasleduješ",
  "notifications.policy.filter_private_mentions_title": "Nevyžiadané priame spomenutia",
  "notifications.policy.title": "Spravuj oznámenia od…",
  "notifications_permission_banner.enable": "Povoliť upozornenia na ploche",
  "notifications_permission_banner.how_to_control": "Ak chcete dostávať upozornenia, keď Mastodon nie je otvorený, povoľte upozornenia na ploche. Po ich zapnutí môžete presne kontrolovať, ktoré typy interakcií generujú upozornenia na ploche, a to prostredníctvom tlačidla {icon} vyššie.",
  "notifications_permission_banner.title": "Nenechajte si nič ujsť",
  "onboarding.follows.back": "Späť",
  "onboarding.follows.empty": "Žiaľ, momentálne sa nedajú zobraziť žiadne výsledky. Môžete skúsiť použiť vyhľadávanie alebo navštíviť stránku objavovania a nájsť ľudí, ktorých chcete sledovať, alebo to skúste znova neskôr.",
  "onboarding.follows.search": "Hľadať",
  "onboarding.follows.title": "Pre začiatok nasleduj ľudí",
  "onboarding.profile.discoverable": "Nastavte svoj profil ako objaviteľný",
  "onboarding.profile.discoverable_hint": "Keď si na Mastodone zapnete objaviteľnosť, vaše príspevky sa môžu zobrazovať vo výsledkoch vyhľadávania a v populárnych. Váš profil môže byť navyše navrhovaný ľuďom, s ktorými máte podobné záujmy.",
  "onboarding.profile.display_name": "Používateľské meno",
  "onboarding.profile.display_name_hint": "Vaše celé meno alebo pokojne aj vtipná prezývka…",
  "onboarding.profile.note": "Niečo o vás",
  "onboarding.profile.note_hint": "Môžete @označiť iných ľudí alebo #hashtagy…",
  "onboarding.profile.title": "Nastavenie profilu",
  "onboarding.profile.upload_avatar": "Nahrať profilový obrázok",
  "onboarding.profile.upload_header": "Nahrať obrázok v záhlaví profilu",
  "password_confirmation.exceeds_maxlength": "Potvrdené heslo presahuje maximálnu dĺžku hesla",
  "password_confirmation.mismatching": "Zadané heslá sa nezhodujú",
  "picture_in_picture.restore": "Vrátiť späť",
  "poll.closed": "Uzatvorená",
  "poll.refresh": "Obnoviť",
  "poll.reveal": "Zobraziť výsledky",
  "poll.total_people": "{count, plural, one {# človek} few {# ľudia} many {# ľudí} other {# ľudí}}",
  "poll.total_votes": "{count, plural, one {# hlas} few {# hlasy} many {# hlasov} other {# hlasov}}",
  "poll.vote": "Hlasovať",
  "poll.voted": "Hlasovali ste za túto voľbu",
  "poll.votes": "{votes, plural, one {# hlas} few {# hlasy} many {# hlasov} other {# hlasov}}",
  "poll_button.add_poll": "Pridať anketu",
  "poll_button.remove_poll": "Odstrániť anketu",
  "privacy.change": "Zmeniť nastavenia súkromia príspevku",
  "privacy.direct.long": "Všetci spomenutí v príspevku",
  "privacy.direct.short": "Spomenutie v súkromí",
  "privacy.private.long": "Iba vaši sledovatelia",
  "privacy.private.short": "Sledovatelia",
  "privacy.public.long": "Ktokoľvek na Mastodone aj mimo neho",
  "privacy.public.short": "Verejné",
  "privacy.quote.disabled": "{visibility}, citovanie nepovolené",
  "privacy.quote.limited": "{visibility}, citovanie obmedzené",
  "privacy.unlisted.additional": "Presne ako verejné, s tým rozdielom, že sa príspevok nezobrazí v živých kanáloch, hashtagoch, objavovaní či vo vyhľadávaní na Mastodone, aj keď máte pre účet objaviteľnosť zapnutú.",
  "privacy.unlisted.short": "Tiché verejné",
  "privacy_policy.last_updated": "Posledná úprava {date}",
  "privacy_policy.title": "Pravidlá ochrany súkromia",
  "quote_error.poll": "Citovanie ankiet nieje povolené.",
  "quote_error.quote": "Je povolená iba jedna citácia súčasne.",
  "quote_error.unauthorized": "Nemáš oprávnenie citovať tento príspevok.",
  "recommended": "Odporúčané",
  "refresh": "Obnoviť",
  "regeneration_indicator.please_stand_by": "Prosím, čakajte.",
  "regeneration_indicator.preparing_your_home_feed": "Pripravuje sa tvoj domáci kanál…",
  "relative_time.days": "{number} dní",
  "relative_time.full.days": "Pred {number, plural, one {# dňom} other {# dňami}}",
  "relative_time.full.hours": "Pred {number, plural, one {# hodinou} other {# hodinami}}",
  "relative_time.full.just_now": "Práve teraz",
  "relative_time.full.minutes": "Pred {number, plural, one {# minútou} other {# minútami}}",
  "relative_time.full.seconds": "Pred {number, plural, one {# sekundou} other {# sekundami}}",
  "relative_time.hours": "{number} hod",
  "relative_time.just_now": "Teraz",
  "relative_time.minutes": "{number} min",
  "relative_time.seconds": "{number} sek",
  "relative_time.today": "Dnes",
  "remove_quote_hint.button_label": "Mám to",
  "remove_quote_hint.title": "Chceš vymazať svoju citáciu príspevku?",
  "reply_indicator.attachments": "{count, plural, one {# príloha} few {# prílohy} other {# príloh}}",
  "reply_indicator.cancel": "Zrušiť",
  "reply_indicator.poll": "Anketa",
  "report.block": "Blokovať",
  "report.block_explanation": "Ich príspevky neuvidíte. Nebudú môcť vidieť vaše príspevky ani vás sledovať. Budú môcť zistiť, že sú zablokovaní.",
  "report.categories.legal": "Právne",
  "report.categories.other": "Ostatné",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Obsah porušuje jedno alebo viacero pravidiel servera",
  "report.category.subtitle": "Vyberte najlepšiu voľbu",
  "report.category.title": "Povedzte nám, čo je zlé na tomto {type}",
  "report.category.title_account": "profile",
  "report.category.title_status": "príspevku",
  "report.close": "Hotovo",
  "report.comment.title": "Je ešte niečo, čo by sme podľa vás mali vedieť?",
  "report.forward": "Preposlať na {target}",
  "report.forward_hint": "Tento účet je z iného serveru. Chcete poslať anonymnú kópiu hlásenia aj tam?",
  "report.mute": "Stíšiť",
  "report.mute_explanation": "Ich príspevky neuvidíte. Stále vás môžu sledovať a vidieť vaše príspevky a nebudú vedieť, že ste ich stíšili.",
  "report.next": "Ďalej",
  "report.placeholder": "Ďalšie komentáre",
  "report.reasons.dislike": "Nepáči sa mi",
  "report.reasons.dislike_description": "Nie je to niečo, čo chcete vidieť",
  "report.reasons.legal": "Je nelegálny",
  "report.reasons.legal_description": "Domnievate sa, že porušuje zákony vašej krajiny alebo krajiny servera",
  "report.reasons.other": "Ide o niečo iné",
  "report.reasons.other_description": "Tento problém nepatrí do iných kategórií",
  "report.reasons.spam": "Je to spam",
  "report.reasons.spam_description": "Škodlivé odkazy, falošné zapojenie alebo opakované odpovede",
  "report.reasons.violation": "Porušuje pravidlá servera",
  "report.reasons.violation_description": "Ste si vedomí, že porušuje špecifické pravidlá",
  "report.rules.subtitle": "Vyberte všetky príslušné možnosti",
  "report.rules.title": "Ktoré pravidlá sú porušované?",
  "report.statuses.subtitle": "Vyberte všetky príslušné možnosti",
  "report.statuses.title": "Sú k dispozícii príspevky podporujúce toto hlásenie?",
  "report.submit": "Odoslať",
  "report.target": "Nahlásiť {target}",
  "report.thanks.take_action": "Tu sú vaše možnosti kontrolovať to, čo vidíte na Mastodone:",
  "report.thanks.take_action_actionable": "Kým to vyhodnotíme, môžete podniknúť kroky voči @{name}:",
  "report.thanks.title": "Nechcete to vidieť?",
  "report.thanks.title_actionable": "Ďakujeme za nahlásenie, pozrieme sa na to.",
  "report.unfollow": "Prestať sledovať @{name}",
  "report.unfollow_explanation": "Tento účet sledujete. Ak už nechcete vidieť jeho príspevky vo svojom domovskom kanáli, prestaňte ho sledovať.",
  "report_notification.attached_statuses": "{count, plural, one {{count} príspevok} few {{count} príspevky} other {{count} príspevkov}} ako príloha",
  "report_notification.categories.legal": "Právne",
  "report_notification.categories.legal_sentence": "nelegálny obsah",
  "report_notification.categories.other": "Ostatné",
  "report_notification.categories.other_sentence": "ostatné",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.violation": "Porušenie pravidla",
  "report_notification.categories.violation_sentence": "porušenie pravidla",
  "report_notification.open": "Otvoriť hlásenie",
  "search.no_recent_searches": "Žiadne nedávne vyhľadávania",
  "search.placeholder": "Hľadať",
  "search.quick_action.account_search": "Profily zodpovedajúce {x}",
  "search.quick_action.go_to_account": "Prejsť na profil {x}",
  "search.quick_action.go_to_hashtag": "Prejsť na hashtag {x}",
  "search.quick_action.open_url": "Otvoriť URL v rámci Mastodonu",
  "search.quick_action.status_search": "Príspevky zodpovedajúce {x}",
  "search.search_or_paste": "Hľadať alebo vložiť adresu URL",
  "search_popout.full_text_search_disabled_message": "Nie je k dispozícii v doméne {domain}.",
  "search_popout.full_text_search_logged_out_message": "Dostupné iba po prihlásení.",
  "search_popout.language_code": "Kód jazyka ISO",
  "search_popout.options": "Možnosti vyhľadávania",
  "search_popout.quick_actions": "Rýchle akcie",
  "search_popout.recent": "Nedávne vyhľadávania",
  "search_popout.specific_date": "Presný dátum",
  "search_popout.user": "Účet",
  "search_results.accounts": "Profily",
  "search_results.all": "Všetky",
  "search_results.hashtags": "Hashtagy",
  "search_results.no_results": "Žiadne výsledky.",
  "search_results.no_search_yet": "Skús vyhľadávať príspevky, profily, alebo hashtagy.",
  "search_results.see_all": "Zobraziť všetky",
  "search_results.statuses": "Príspevky",
  "search_results.title": "Hľadaj \"{q}\"",
  "server_banner.about_active_users": "Ľudia používajúci tento server za posledných 30 dní (aktívni používatelia za mesiac)",
  "server_banner.active_users": "Aktívne účty",
  "server_banner.administered_by": "Správa servera:",
  "server_banner.is_one_of_many": "{domain} je jeden z mnohých nezávislých Mastodon serverov, ktoré môžeš použiť na zúčastňovanie sa v rámci fediversa.",
  "server_banner.server_stats": "Štatistiky servera:",
  "sign_in_banner.create_account": "Vytvoriť účet",
  "sign_in_banner.mastodon_is": "Mastodon je najlepšia cesta ako udržať krok s tým, čo sa deje.",
  "sign_in_banner.sign_in": "Prihlásiť sa",
  "sign_in_banner.sso_redirect": "Prihlásenie alebo registrácia",
  "status.admin_account": "Moderovať @{name}",
  "status.admin_domain": "Moderovať {domain}",
  "status.admin_status": "Moderovať príspevok",
  "status.all_disabled": "Zdieľania a citácie sú vypnuté",
  "status.block": "Blokovať @{name}",
  "status.bookmark": "Pridať záložku",
  "status.cancel_reblog_private": "Zrušiť zdieľanie",
  "status.cannot_reblog": "Tento príspevok nie je možné zdieľať",
  "status.context.show": "Zobraziť",
  "status.continued_thread": "Pokračujúce vlákno",
  "status.copy": "Kopírovať odkaz na príspevok",
  "status.delete": "Vymazať",
  "status.delete.success": "Príspevok vymazaný",
  "status.detailed_status": "Podrobný náhľad celej konverzácie",
  "status.direct": "Súkromne označiť @{name}",
  "status.direct_indicator": "Súkromné označenie",
  "status.edit": "Upraviť",
  "status.edited": "Naposledy upravený {date}",
  "status.edited_x_times": "Upravený {count, plural, other {{count}×}}",
  "status.favourite": "Ohviezdičkovať",
  "status.filter": "Filtrovanie tohto príspevku",
  "status.history.created": "Vytvorené účtom {name} {date}",
  "status.history.edited": "Upravené účtom {name} {date}",
  "status.load_more": "Načitať viac",
  "status.media.open": "Otvoriť kliknutím",
  "status.media.show": "Zobraziť kliknutím",
  "status.media_hidden": "Skryté médiá",
  "status.mention": "Označiť @{name}",
  "status.more": "Viac",
  "status.mute": "Stíšiť @{name}",
  "status.mute_conversation": "Stíšiť konverzáciu",
  "status.open": "Rozbaliť príspevok",
  "status.pin": "Pripnúť na profil",
  "status.quote_error.not_available": "Príspevok je nedostupný",
  "status.quote_noun": "Citácia",
  "status.quote_policy_change": "Zmeňte, kto vás môže citovať",
  "status.quote_post_author": "Citoval/a príspevok od @{name}",
  "status.quote_private": "Súkromné príspevky nemožno citovať",
  "status.read_more": "Čítaj ďalej",
  "status.reblog": "Zdieľať",
  "status.reblog_or_quote": "Zdieľať alebo citovať",
  "status.reblogged_by": "{name} zdieľa",
  "status.reblogs.empty": "Nikto ešte tento príspevok nezdieľal. Keď tak niekto urobí, zobrazí sa to tu.",
  "status.redraft": "Vymazať a prepísať",
  "status.remove_bookmark": "Odstrániť záložku",
  "status.remove_favourite": "Zrušiť ohviezdičkovanie",
  "status.replied_in_thread": "Odpovedal/a vo vlákne",
  "status.replied_to": "Odpoveď na {name}",
  "status.reply": "Odpovedať",
  "status.replyAll": "Odpovedať vo vlákne",
  "status.report": "Nahlásiť @{name}",
  "status.sensitive_warning": "Citlivý obsah",
  "status.share": "Zdieľať",
  "status.show_less_all": "Všetkým zobraziť menej",
  "status.show_more_all": "Všetkým zobraziť viac",
  "status.show_original": "Zobraziť originál",
  "status.title.with_attachments": "Účet {user} nahral {attachmentCount, plural, one {prílohu} few {{attachmentCount} prílohy} many {{attachmentCount} príloh} other {{attachmentCount} príloh}}",
  "status.translate": "Preložiť",
  "status.translated_from_with": "Preložené z {lang} pomocou {provider}",
  "status.uncached_media_warning": "Náhľad nie je k dispozícii",
  "status.unmute_conversation": "Zrušiť stíšenie konverzácie",
  "status.unpin": "Odopnúť z profilu",
  "subscribed_languages.lead": "Po zmene sa na vašej domovskej stránke a časovej osi zoznamu zobrazia iba príspevky vo vybraných jazykoch. Ak chcete dostávať príspevky vo všetkých jazykoch, vyberte možnosť žiadne.",
  "subscribed_languages.save": "Uložiť zmeny",
  "subscribed_languages.target": "Zmeniť prihlásené jazyky pre {target}",
  "tabs_bar.home": "Domov",
  "tabs_bar.notifications": "Upozornenia",
  "tabs_bar.publish": "Nový príspevok",
  "tabs_bar.search": "Vyhľadávanie",
  "terms_of_service.effective_as_of": "Platí od {date}",
  "terms_of_service.title": "Podmienky prevozu",
  "terms_of_service.upcoming_changes_on": "Zmeny nadchádzajúce od {date}",
  "time_remaining.days": "Ostáva{number, plural, one { # deň} few {jú # dni} many { # dní} other { # dní}}",
  "time_remaining.hours": "Ostáva{number, plural, one { # hodina} few {jú # hodiny} many { # hodín} other { # hodín}}",
  "time_remaining.minutes": "Ostáva{number, plural, one { # minúta} few {jú # minúty} many { # minút} other { # minút}}",
  "time_remaining.moments": "Ostáva už iba chviľka",
  "time_remaining.seconds": "Ostáva{number, plural, one { # sekunda} few {jú # sekundy} many { # sekúnd} other { # sekúnd}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} osoba} few {{counter} ľudia} many {{counter} ľudí} other {{counter} ľudí}} za posledn{days, plural, one {ý deň} few {é {days} dni} many {ých {days} dní} other {ých {days} dní}}",
  "trends.trending_now": "Teraz populárne",
  "ui.beforeunload": "Po opustení Mastodonu prídete o to, čo máte rozpísané.",
  "units.short.billion": "{count} mld.",
  "units.short.million": "{count} mil.",
  "units.short.thousand": "{count} tis.",
  "upload_area.title": "Nahráte potiahnutím a pustením",
  "upload_button.label": "Pridať obrázky, video alebo zvukový súbor",
  "upload_error.limit": "Limit pre nahrávanie súborov bol prekročený.",
  "upload_error.poll": "Nahrávanie súborov nie je pri anketách možné.",
  "upload_form.edit": "Upraviť",
  "upload_progress.label": "Nahráva sa…",
  "upload_progress.processing": "Spracovávanie…",
  "username.taken": "Používateľské meno je obsadené. Skúste iné",
  "video.close": "Zatvoriť video",
  "video.download": "Stiahnuť súbor",
  "video.exit_fullscreen": "Ukončiť režim celej obrazovky",
  "video.expand": "Zväčšiť video",
  "video.fullscreen": "Zobraziť na celú obrazovku",
  "video.hide": "Skryť video",
  "video.mute": "Stíšiť",
  "video.pause": "Pozastaviť",
  "video.play": "Prehrať",
  "video.volume_down": "Hlasitosť nadol",
  "video.volume_up": "Hlasitosť nahor",
  "visibility_modal.header": "Viditeľnosť a interakcia",
  "visibility_modal.quote_followers": "Iba sledujúce účty",
  "visibility_modal.quote_label": "Kto vás môže citovať",
  "visibility_modal.quote_nobody": "Iba ja",
  "visibility_modal.quote_public": "Ktokoľvek",
  "visibility_modal.save": "Uložiť"
}
